<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="box">
                <div class="box-body" style="padding: 8px;">
                    <div class="row">
                        <div class="col-md-9">&nbsp;</div>
                        <div class="col-md-3">
                            <div class="float-lg-right">
                                <daterange :dateRange="filters.dateRange" v-on:onChange="onDateFilterChanged" :singleDatePicker=true />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <autoupdate :loading="reportDataLoading" v-on:refreshData="loadData" />
            <div class="box">
                <div class="box-header" style="padding-top: 3px; padding-bottom:3px;">&nbsp;</div>
                <div class="box-tool" style="top: 4px;">
                    <ul class="nav">
                        <li class="nav-item inline">
                            <a class="nav-link" v-on:click="downloadCsv"><span class="fa fa-download"></span></a>
                        </li>
                    </ul>
                </div>
                <table2 :rows="data" :headers="tableHeaders" :initialSortColumn="2" initialSortBy="desc" />
            </div>
        </div>
    </div>
</template>

<script>
    import Select2 from '../../../components/select.v2.vue';
    import DateRange from '../../../components/daterange.vue';
    import moment from 'moment';
    import $ from 'jquery';
    import AutoUpdate from '../../../components/auto_update.vue';
    import Table2 from '../../../components/table.v2.vue';
    import TimezoneChangeMixin from '../../../mixins/timezone-change.vue';

    export default {
        mixins: [TimezoneChangeMixin],
        components: {
            'select2': Select2,
            'daterange': DateRange,
            'autoupdate': AutoUpdate,
            'table2': Table2
        },
        props: ['feed'],
        data: function () {
            return {
                filters: {
                    dateRange: [moment(), moment()]
                },
                data: [],
                loading: false,
                reportDataLoading: false,
                csvDownloadUrl: '',
                tableHeaders: [
                    {
                        columnName: 'app_name',
                        title: 'Uygulama',
                        dataFormat: 'string',
                        isHtml: true
                    },
                    {
                        columnName: 'new_score',
                        title: 'Yeni Puan',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'avg_score',
                        title: 'Ortalama Puan',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    }
                ]
            }
        },
        mounted: function () {
            this.loading = false;
            this.loadData();
        },
        methods: {
            loadData: function () {
                this.reportDataLoading = true;
                var $this = this;
                var params = {
                    id: this.$router.currentRoute.query.id,
                    date: this.filters.dateRange[0].format('YYYY-MM-DD')
                };
                this.$app.get('/api/v1/dashboards/report/iosappranking/popular-new-data', params, function(xhr) {
                    $this.reportDataLoading = false;
                    var response = xhr.responseJSON;
                    $this.data = response.data;
                    params.access_token = $this.$app.getAccessToken();
                    params.csv = 1;
                    $this.csvDownloadUrl = '/api/v1/dashboards/report/iosappranking/popular-new-data?' + $.param(params);
                }, {'Timezone': this.$app.getTimezone()});
            },
            downloadCsv: function () {
                if (this.csvDownloadUrl !== '') {
                    window.open(this.csvDownloadUrl);
                }
            },
            onDateFilterChanged: function (data) {
                this.filters.dateRange = data;
                this.loadData();
            }
        }
    }
</script>

<style scoped>
    th {
        font-size: 11px;
    }
</style>


// WEBPACK FOOTER //
// popular_new.vue?298e1968